import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import DoneAllOutlined from '@mui/icons-material/DoneAllOutlined';
import EventOutlined from '@mui/icons-material/EventOutlined';
import { PortalJob } from '../../types/portal';
import { formatDate, formatDateTime } from '../../utils';
import styles from './portal.module.css';

/**
 * The one date that matters for a job: when it is planned while it is still
 * open, and when it was finished once it is done. Which one it is comes from
 * the API, so the list and the detail view can never disagree.
 */
export const PortalJobDate = ({ job }: { job: PortalJob }) => {
  const { t } = useTranslation();

  const isFinished = job.display_date_kind === 'finished';
  const value = job.display_date;

  return (
    <Box className={styles.metaItem}>
      {isFinished ? (
        <DoneAllOutlined fontSize="small" color="success" />
      ) : (
        <EventOutlined fontSize="small" />
      )}
      {isFinished ? t('Finished at') : t('Planned for')}:{' '}
      {/* planned_for is a plain date, finished_at a timestamp - formatted the
          same way the staff app formats each. */}
      {value
        ? (isFinished ? formatDateTime(value) : formatDate(value))
        : t('Not scheduled yet')}
    </Box>
  );
};
